import axios from "axios";
import { BASE_URL } from "../constants/api-end-pionts";

const postApiServices = async (url: string, body: Object, config: Object = {}) => {
  const bearerToken = localStorage.getItem("token");

  let api = axios.create({
    baseURL: BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    ...config,
  });

  try {
    let data = await api.post(url, body);
    return data;
  } catch (e) {
    throw e;
  }
};

export default postApiServices;